import cn from 'classnames';
import { motion } from 'framer-motion';
import { Button, Column, Row, TextButton, Typography } from 'seagull';
import { AnchorIcon, ArrowForward } from 'seagull/icons';
import { useResponsive } from "../../../../client-flow/contexts";
import { useCreateVendorAccount } from "../../../../hooks/useCreateVendorAccount/useCreateVendorAccount";
import { Intent } from "../../../../infra/access-control";
import styles from "./CreateAVendorAccount.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AnimatedArrowForward = () => /*#__PURE__*/_jsx(motion.div, {
  style: {
    width: 28,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  animate: {
    x: [-2, 2, -2]
  },
  transition: {
    duration: 1,
    ease: 'linear',
    repeat: Infinity
  },
  children: /*#__PURE__*/_jsx(ArrowForward, {})
});
export const CreateAVendorAccount = _ref => {
  let {
    variant,
    onClick,
    testId = 'create-a-vendor-account-btn'
  } = _ref;
  const onCreateVendorAccount = useCreateVendorAccount(onClick);
  const {
    isDesktop
  } = useResponsive();
  const VariantContent = () => {
    switch (variant) {
      case 'banner':
        return /*#__PURE__*/_jsx(TextButton, {
          as: "div",
          intent: Intent.ClientCreateVendorAccount,
          className: cn(styles.banner, {
            [styles.mobile]: !isDesktop
          }),
          testId: testId,
          onClick: onCreateVendorAccount,
          children: /*#__PURE__*/_jsxs(Row, {
            className: styles.bannerContent,
            children: [isDesktop && /*#__PURE__*/_jsx(AnchorIcon, {
              style: {
                height: 56,
                width: 56
              }
            }), /*#__PURE__*/_jsxs(Column, {
              children: [/*#__PURE__*/_jsx(Typography, {
                variant: "h6",
                weight: "normal",
                children: "Try Anchor for your business"
              }), /*#__PURE__*/_jsx(Typography, {
                variant: "paragraph1",
                children: "Send proposals, bill, and get paid. As simple as that."
              })]
            }), /*#__PURE__*/_jsxs(Button, {
              style: {
                minWidth: !isDesktop && 40
              },
              intent: Intent.ClientCreateVendorAccount,
              testId: "".concat(testId, "-button"),
              children: [isDesktop ? 'Get started free' : '', " ", /*#__PURE__*/_jsx(AnimatedArrowForward, {})]
            })]
          })
        });
      case 'button':
        return /*#__PURE__*/_jsx("div", {
          "data-testid": "create-a-vendor-account",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: onCreateVendorAccount,
            testId: testId,
            intent: Intent.ClientCreateVendorAccount,
            children: "Create a Service Provider Account"
          })
        });
      case 'text':
        return /*#__PURE__*/_jsxs("div", {
          "data-testid": "create-a-vendor-account",
          children: [/*#__PURE__*/_jsx(TextButton, {
            className: styles.createVendorPromptText,
            underline: "none",
            onClick: onCreateVendorAccount,
            testId: testId,
            intent: Intent.ClientCreateVendorAccount,
            children: "Sign up for a service provider account"
          }), /*#__PURE__*/_jsxs(Typography, {
            as: "span",
            className: styles.createVendorPromptText,
            children: [' ', "- it's free"]
          })]
        });
    }
  };
  return /*#__PURE__*/_jsx(VariantContent, {});
};